export default "__VITE_ASSET__f393abb6__"